import { PluginKey } from '@atlaskit/editor-prosemirror/state';
export var editorToolbarPluginKey = new PluginKey('editorToolbarPluginKey');